import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronBackActive = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.4754 3.71209C13.8415 4.0782 13.8415 4.6718 13.4754 5.03791L8.51333 10L13.4754 14.9621C13.8415 15.3282 13.8415 15.9218 13.4754 16.2879C13.1093 16.654 12.5157 16.654 12.1496 16.2879L6.52459 10.6629C6.15847 10.2968 6.15847 9.7032 6.52459 9.33709L12.1496 3.71209C12.5157 3.34597 13.1093 3.34597 13.4754 3.71209Z",
		fill: "#50566E"
	})
});
export default SvgChevronBackActive;
